import LegalPageLayout from "../../components/elements/legal-page-layout";

const toc = [
  { id: "contratacao", label: "Contratação" },
  { id: "agendamento", label: "Agendamento" },
  { id: "pagamento", label: "Pagamento" },
  { id: "cancelamento", label: "Cancelamento" },
  { id: "entregas", label: "Correções e materiais" },
  { id: "reembolso", label: "Reembolso" },
];

export default function TermosContratacao() {
  return (
    <LegalPageLayout
      eyebrow="Condições dos serviços"
      title="Termos de Contratação"
      description="Conheça as condições gerais aplicáveis à contratação de aulas, mentorias e correções."
      toc={toc}
    >
      <div className="ep-note">
        <p>
          <strong>Última atualização:</strong> 08 de setembro de 2026.
          Modelo sujeito a revisão jurídica e adequação à forma de cobrança
          utilizada pela empresa.
        </p>
      </div>

      <h2 id="contratacao">1. Contratação dos serviços</h2>
      <p>
        A contratação será considerada confirmada após o aceite das condições
        comerciais e, quando aplicável, a confirmação do pagamento. Modalidade,
        quantidade de encontros, duração, preço e demais condições serão
        informados antes da contratação.
      </p>

      <h2 id="agendamento">2. Agendamento e aulas</h2>
      <p>
        Os horários serão definidos de acordo com a disponibilidade da
        professora e do aluno. O acesso às aulas online é de responsabilidade
        do aluno, que deverá possuir conexão e recursos adequados.
      </p>

      <h2>3. Reagendamento e faltas</h2>
      <p>
        Solicitações de reagendamento deverão observar a antecedência definida
        na proposta ou contratação. Faltas sem aviso ou fora do prazo poderão
        ser consideradas como encontro realizado, quando essa condição tiver
        sido previamente informada e aceita.
      </p>

      <h2 id="pagamento">4. Pagamento</h2>
      <p>
        Valores, formas de pagamento, vencimentos e condições promocionais
        serão apresentados antes da confirmação. O não pagamento poderá
        resultar na suspensão de novos atendimentos até a regularização.
      </p>

      <h2 id="cancelamento">5. Cancelamento</h2>
      <p>
        O cancelamento poderá ser solicitado pelos canais oficiais de
        atendimento. Quando a contratação ocorrer à distância, serão
        observados os direitos do consumidor e demais regras legais aplicáveis.
      </p>

      <h2 id="entregas">6. Correções e materiais</h2>
      <p>
        Os prazos de entrega de correções, materiais ou feedback serão
        informados na contratação. O prazo poderá ser alterado em situações
        excepcionais, mediante comunicação ao aluno.
      </p>

      <h2 id="reembolso">7. Reembolso</h2>
      <p>
        Eventuais reembolsos serão tratados conforme a legislação aplicável,
        a modalidade contratada e as condições comerciais previamente
        apresentadas, respeitados os direitos do consumidor.
      </p>

      <h2>8. Responsabilidades</h2>
      <p>
        A professora se compromete a prestar o serviço contratado dentro das
        condições acordadas. O aluno se compromete a fornecer informações
        adequadas, cumprir horários, realizar atividades e manter os canais de
        contato atualizados.
      </p>

      <h2>9. Resultados educacionais</h2>
      <p>
        A contratação não representa garantia de nota, aprovação, classificação
        ou resultado específico. O desempenho depende também da dedicação,
        participação e evolução individual do aluno.
      </p>

      <h2>10. Aceite</h2>
      <p>
        Ao confirmar a contratação, o aluno declara ter tido acesso às
        condições aplicáveis ao serviço escolhido e concorda com estes termos,
        sem prejuízo dos direitos assegurados pela legislação.
      </p>
    </LegalPageLayout>
  );
}
